<div [ngClass]="{'import-block__completed': !isActive() && stepState == ImportStepState.Completed, 'import-block__collapsed': !isActive() && stepState == ImportStepState.Available, 'import-block__not-available': stepState <= ImportStepState.NotAvailableYet, 'loading': dataLoading }"
    class="import-block">
    <div class="d-flex align-items-center">
        <div class="number-circle"><span [ngClass]="{'subtitle-2': stepState !== ImportStepState.Completed, 'material-icons-outlined': (stepState === ImportStepState.Completed && !isActive())}">{{
                (stepState === ImportStepState.Completed && !isActive()) ? 'check' : '10' }}</span></div>
        <h4>Duplication</h4>
    </div>
    <ng-container *ngIf="isActive()">
        <div class="body-1 mb-24">{{numOfNotUniqueCombinations}} ({{percOfNotUniqueCombinations}}%) of the {{numOfCombinations}} unique combinations across
            the {{numOfDimensions}} selected dimensions (e.g. {{dimensionsNames}}) contain duplicate records
            for {{oldControlColumnValue}} or {{newControlColumnValue}}.</div>
        <div class="body-1 mb-8">Select your preferred strategy to remove such duplication.</div>
        <div class="radio-group separate-blocks flex-column">
            <label>
                <input [(ngModel)]="selectedStrategy" [value]="PreaggregationStrategy.withoutFormula" type="radio">
                <div class="radio-option">
                    <div class="radio-circle"></div>
                    <div class="radio-content">
                        <span class="subtitle-1">Only analyse {{outcomeColumnName}} variance</span>
                        <span class="body-2">Disregard {{formulaComponentsNames}} variance.</span>
                    </div>
                </div>
            </label>
            <label>
                <input [(ngModel)]="selectedStrategy" [value]="PreaggregationStrategy.reuploadFile" type="radio">
                <div class="radio-option">
                    <div class="radio-circle"></div>
                    <div class="radio-content">
                        <span class="subtitle-1">Go back and re-upload corrected data</span>
                        <span class="body-2">It is highly recommended to work with a dataset that for all relevant analysis combinations includes ONE record for {{oldControlColumnValue}} and ONE
                            for {{newControlColumnValue}}.</span>
                    </div>
                </div>
            </label>
            <label>
                <input [(ngModel)]="selectedStrategy" [value]="PreaggregationStrategy.reselectDimensions" type="radio">
                <div class="radio-option">
                    <div class="radio-circle"></div>
                    <div class="radio-content">
                        <span class="subtitle-1">Select additional dimensions manually to reduce the combinations with multiple records</span>
                        <span class="body-2">This strategy will further reduce the number of combinations that include one record for both {{oldControlColumnValue}} and {{newControlColumnValue}}
                            and can be compared across.</span>
                    </div>
                </div>
            </label>
            <label>
                <input [(ngModel)]="selectedStrategy" [value]="PreaggregationStrategy.averageAndSum" type="radio">
                <div class="radio-option">
                    <div class="radio-circle"></div>
                    <div class="radio-content">
                        <span class="subtitle-1">Sum up <span *ngIf="summedColumnNames">{{summedColumnNames}}</span> and average up {{averagedColumnNames}}</span>
                        <span class="body-2">This is a valid option, even if it would be best to rework the original upload file so that it does not include duplication.</span>
                    </div>
                </div>
            </label>
        </div>
        <div>
            <button (click)="selectStrategy()" [ngClass]="{'loading-small':loading, 'btn':true}">Continue</button>
        </div>
    </ng-container>
    <ng-container *ngIf="!isActive() && stepState == ImportStepState.Completed">
        <div class="info-block">
            <span class="body-1">Logic</span>
            <span class="body-1 text-900"></span>
        </div>
        <div>
            <button (click)="editClick()" [ngClass]="{'loading-small':loading}" class="btn btn-secondary btn-icon btn-edit"><span class="material-icons-outlined">edit</span></button>
        </div>
    </ng-container>
</div>

<div *ngIf="false" class="import-block">
    <div class="wrap">
        <div>
            <div class="d-flex align-items-center">
                <div class="mr-8"><span class="material-icons-outlined text-warning">warning_amber</span></div>
                <h4>Comparison with warning sign</h4>
            </div>
        </div>
    </div>
</div>
